import { api } from './api';
import { User } from '../types';

export interface CreateUserData {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  role: string;
}

export interface UpdateUserData {
  firstName?: string;
  lastName?: string;
  email?: string;
}

export interface UserListResponse {
  users: User[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export const userService = {
  // Get all users
  getUsers: async (params?: {
    page?: number;
    limit?: number;
    search?: string;
    role?: string;
    isActive?: boolean;
  }) => {
    const response = await api.get<{ data: UserListResponse }>('/users', { params });
    return response.data.data;
  },

  // Get single user
  getUser: async (id: string) => {
    const response = await api.get<{ data: User }>(`/users/${id}`);
    return response.data.data;
  },

  // Create user
  createUser: async (data: CreateUserData) => {
    const response = await api.post<{ data: User }>('/users', data);
    return response.data.data;
  },

  // Update user
  updateUser: async (id: string, data: UpdateUserData) => {
    const response = await api.put<{ data: User }>(`/users/${id}`, data);
    return response.data.data;
  },

  // Update user role
  updateUserRole: async (id: string, role: string) => {
    const response = await api.patch<{ data: User }>(`/users/${id}/role`, { role });
    return response.data.data;
  },

  // Toggle user status
  toggleUserStatus: async (id: string) => {
    const response = await api.patch<{ data: User }>(`/users/${id}/status`);
    return response.data.data;
  },

  // Reset user password
  resetUserPassword: async (id: string, newPassword: string) => {
    const response = await api.post<{ data: any }>(`/users/${id}/reset-password`, { newPassword });
    return response.data.data;
  },

  // Delete user
  deleteUser: async (id: string) => {
    const response = await api.delete<{ data: any }>(`/users/${id}`);
    return response.data.data;
  },

  // Get user permissions
  getUserPermissions: async (id: string) => {
    const response = await api.get<{ data: { user: User; permissions: string[] } }>(`/users/${id}/permissions`);
    return response.data.data;
  },

  // Get my permissions
  getMyPermissions: async () => {
    const response = await api.get<{ data: { role: string; permissions: string[] } }>('/users/my-permissions');
    return response.data.data;
  },
};
